import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { useState } from 'react'
import draftToHtml from 'draftjs-to-html';

const HtmlContentEditor = ({ value, setValue, disabled }) => {

    const [editorState, setEditorState] = useState(() => EditorState.createEmpty());

    const save = () => {
        let html = draftToHtml(convertToRaw(editorState.getCurrentContent()))
        html = html.replace(/(?:\r\n|\r|\n)/g, '<br>');
        setValue(html)
    }

    return (
        <div className="widget-container">
            <Editor
                editorState={editorState}
                onEditorStateChange={setEditorState}
                localization={{ locale: 'pl' }}
                wrapperClassName="textEditorTools"
                editorClassName="textEditor"
                onChange={save}
                toolbarHidden={true}
            />
        </div>
    )
}

export { HtmlContentEditor }